"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillSelect = void 0;
function fillSelect(elements, selectHTMLElement) {
    elements.forEach((element) => {
        const options = document.createElement('option');
        if (typeof element === 'string') {
            options.id = element.toLocaleLowerCase();
            options.value = `wordCollection${element.split('_').join('')}.json`;
            options.innerText = element.split('_').join(' ');
        }
        if (typeof element === 'number') {
            options.id = `round_${element}`;
            options.value = String('0' + element).slice(-2);
            options.innerText = String('0' + element).slice(-2);
        }
        selectHTMLElement.append(options);
    });
}
exports.fillSelect = fillSelect;
